"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_SHOW_BLOQUEO_NUMERO_COLUMNS_MAP = void 0;
exports.SORTABLE_SHOW_BLOQUEO_NUMERO_COLUMNS_MAP = {
    id: 'bloq_id',
    ani: 'bloq_telefono',
    // cliente: 'clie_nombre_corto',
    motivo: 'bloq_motivo',
    fecha_bloqueo: 'bloq_fecha_doc',
    fecha_ingreso: 'bloq_fecha',
    estado: 'bloq_estado',
};
